import React from "react";
import { Input, Table } from "antd";
import { getStatusColor } from "../../util/statusColor";
import { useNavigate } from "react-router-dom";
import TableFilter from "../TableFilter";
import TableAction from "../TableAction";

type ContractsTableProps = {
  searchText: string;
  setSearchText?: (text: string) => void;
  filteredContracts?: any[];
  isLoading?: boolean;
  selectedFilterIndex?: number;
  setSelectedFilterIndex: (index: number) => void;
  filters?: any[];
};

const contractsColumn = [
  {
    title: "Contract Number",
    dataIndex: "contractNumber",
    key: "contractNumber",
  },
  {
    title: "Off Taker",
    dataIndex: "offTaker",
    key: "offTaker",
  },
  {
    title: "Full Name",
    dataIndex: "fullName",
    key: "fullName",
  },
  {
    title: "Product",
    dataIndex: "product",
    key: "product",
  },
  {
    title: "Quantity",
    dataIndex: "quantity",
    key: "quantity",
  },
  {
    dataIndex: "contractStatus",
    title: "Status",
    render: (text: string) => (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          paddingTop: 6,
          paddingBottom: 6,
          borderRadius: 8.5,
          color: getStatusColor(text),
          backgroundColor: `${getStatusColor(text)}44`,
        }}
      >
        {text}
      </div>
    ),
  },
];

const ContractsTable: React.FC<ContractsTableProps> = ({
  searchText,
  setSearchText,
  filteredContracts,
  isLoading,
  selectedFilterIndex,
  setSelectedFilterIndex,
  filters,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="hidden md:block">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: 80,
            backgroundColor: "#EEF3F8",
            borderRadius: 8.4,
            marginBottom: 12,
          }}
        >
          {setSearchText && <TableAction setSearchText={setSearchText} />}
        </div>
        <TableFilter
          defaultIndex={0}
          filters={filters || []}
          setSelectedFilterIndex={setSelectedFilterIndex}
        />
        <div className=" h-full" style={{ overflow: "hidden" }}>
          <Table
            style={{
              cursor: "pointer",
              position: "relative",
              zIndex: 100,
              overflowY: "hidden",
            }}
            scroll={{ y: 600 }}
            dataSource={filteredContracts}
            columns={contractsColumn}
            loading={isLoading}
            onRow={(record, index) => {
              return {
                onClick: (event) => {
                  navigate(`/contracts/${record.id}`);
                },
              };
            }}
          />
        </div>
      </div>
      <div className="w-full grid grid-col divide-y-2 divide-green-400 md:hidden px-2">
        <Input
          onChange={(e) => setSearchText && setSearchText(e.target.value)}
          placeholder="Search"
          style={{ backgroundColor: "#08453E" }}
          className="bg-[#08453E] text-white h-[40px] my-2"
        />
        {filteredContracts?.map((item: any) => (
          <div
            key={item.id}
            className="w-full flex justify-between items-center pt-2"
            onClick={() => {
              navigate(`/contracts/${item.id}`);
            }}
          >
            <div className="flex gap-4 font-bold text-lg text-white">
              <div className="flex flex-col">
                <div>
                  {item.offTaker} ({item.contractNumber})
                </div>
                <div className="text-sm text-gray-300">{item.fullName}</div>
                <div className="text-sm text-gray-300">
                  {item.product} ({item.quantity} qt)
                </div>
              </div>
            </div>
            <div
              style={{
                width: "30%",
                color: getStatusColor(item.contractStatus),
                backgroundColor: `${getStatusColor(item.contractStatus)}44`,
              }}
              className="flex justify-center items-center py-[6px] px-3 rounded-xl"
            >
              {item.contractStatus}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ContractsTable;
